import React from "react"
import { graphql } from "gatsby"

import { Meta } from "@shared"
import { CONSTANTS } from "@data"
import { logTool, featureFlag } from "@jsUtils"

import {
  Footer,
  Header,
  HeroGrid,
  CompanyPillars,
  Banner,
  // Video,
  OurPeople,
  Podcast,
  ThoughtLeadership,
  EmailModal
} from "@components/sections"

import Styles from "@pageStyles/ourvision.module.scss"

const { PAGE_NAMES, THEMES, COLORS, PAGE_TRACKER_KEYS, PAGE_TRACKER_VALUES } = CONSTANTS

const log = logTool()

/**
 * Vision Page
 * @param {object} props - react props
 * @todo hook up meta data
 */
// eslint-disable-next-line no-unused-vars
const VisionPage = props => {
  const { data } = props
  const { contentfulPageMeta, contentfulVision, contentfulCrmEventBasedModal } = data
  const { topBanner, banner, companyPillars, ourPeople, articles } = contentfulVision
  const { isModalEnabledOnSite } = contentfulCrmEventBasedModal

  return (
    <>
      <Meta
        base={contentfulPageMeta}
        page={contentfulVision}
        hubSpotObj={{
          contentTypeKey: PAGE_TRACKER_KEYS.VISION_PAGE,
          contentTypeValue: PAGE_TRACKER_VALUES.WEBSITE_PAGE
        }}
      />

      <Header theme={THEMES.DARK} pageColor={COLORS.DARK} />
      <HeroGrid
        theme={THEMES.DARK}
        color={COLORS.FLURO}
        page={PAGE_NAMES.VISION}
        content={contentfulVision}
        levels={{
          headerText: 2
        }}
        classes={{
          headerText: Styles.headerText,
          extraHeroSection: Styles.heroSection,
          extraHeroWrapperRow: Styles.heroWrapperRow,
          extraPageHeadingContent: Styles.pageHeadingContent
        }}
      />
      {featureFlag("visionTopBanner") && <Banner data={topBanner} />}
      {/* featureFlag("visionVideo") && <Video data={video} /> */}
      {/* <ThreeColImageText
        theme={THEMES.SLATE}
        color={COLORS.FLURO}
        gridLines
        items={mission}
        eyebrow="Our Mission"
        title={missionTitle}
        titleSize={4}
        itemTitleSize={3}
        imageBackgroundCircle={false}
        spacingSmall
        hideItemDescription
        mobileTwoCol
      /> */}
      <CompanyPillars color={COLORS.FLURO} theme={THEMES.DARK} data={companyPillars} />
      {featureFlag("visionOurPeople") && (
        <OurPeople theme={THEMES.LIGHT} color={COLORS.FLURO} data={ourPeople} />
      )}
      {featureFlag("visionThoughLeadership") && (
        <ThoughtLeadership theme={THEMES.LIGHT} color={COLORS.FLURO} data={articles} />
      )}
      <Podcast theme={THEMES.LIGHT} color={COLORS.FLURO} />
      <Banner data={banner} />
      {isModalEnabledOnSite ? (
        <EmailModal data={contentfulCrmEventBasedModal} theme={THEMES.DARK} color={COLORS.FLURO} />
      ) : null}
      <Footer />
    </>
  )
}

/**
 * pageQuery for Our Vision Page
 * @todo is there a way to make the global data a fragment?
 */
export const pageQuery = graphql`
  {
    contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      ...GlobalMetaData
    }
    contentfulCrmEventBasedModal {
      heroImage {
        title
        fluid(quality: 100, maxWidth: 1920) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      supportingText
      heroText
      isModalEnabledOnSite
    }
    contentfulVision {
      pageMeta {
        ...PageMetaData
      }
      eyebrow
      headline
      topBanner {
        ...BannerSection
      }
      missionTitle
      mission {
        id
        title
        description {
          childMarkdownRemark {
            html
          }
        }
        image {
          title
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
      }
      # video {
      #   ...VideoSection
      # }
      companyPillars {
        ...CompanyPillarsSection
      }
      ourPeople {
        ...OurPeopleSection
      }
      articles {
        ...ThoughtLeadershipSection
      }
      banner {
        ...BannerSection
      }
    }
  }
`

export default VisionPage
